import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute(
  '/_authenticated/_layout/(deprecated)/workspaces/$subscriptionId/visits/$requestId'
)({
  beforeLoad: ({ params: { subscriptionId, requestId } }) => {
    return redirect({
      to: AppRoute.IdentificationEventDetails,
      params: { subscriptionId, requestId },
      search: true,
      replace: true,
    })
  },
})
